// NHO survey translations.
// FR/NL question text (q2-q14) comes from the HR-approved sheet
// "NHO Translationo French & Dutch 10 Aug 2026.xlsx" (sheet: NEW).
// The remaining strings (title, intro, legend, note, q1, placeholders,
// validation message) were AI-drafted and still need HR sign-off.
const nhoTranslations = {
  en: {
    title: "We Love To Hear Your Onboarding Experience",
    intro: "Your feedback is important to us and these will help improve our New Hire Orientation experience for new hire associates. Rating is 1 to 5 where 5 is the highest.",
    legend: ["1 - Highly Dissatisfied", "2 - Dissatisfied", "3 - Neutral", "4 - Satisfied", "5 - Highly Satisfied"],
    note: "Note: All information is required so please ensure that all fields are completed.",
    q1: "1. When did you have your New Hire Orientation? (Date of NHO)",
    q2: "2. How would you rate your Over-all Week-1 Employee Onboarding Experience with Eastvantage?",
    q3: "3. How would you rate your Over-all Experience with the Recruitment process?",
    q4: "4. I am aware of the New Hire Orientation Schedule.",
    q5: "5. The topics covered during New Hire Orientation are relevant as a new hire.",
    q6: "6. Choose your Facilitator",
    q7: "7. The facilitator/s were highly knowledgeable about the topics.",
    q8: "8. The facilitator/s were able to present in a clear and understandable manner.",
    q9: "9. The facilitator/s were able to answer my questions.",
    q10: "10. My EV equipment is working properly.",
    q11: "11. I was able to login to my webmail, EVOX and BHR during my Day 1.",
    q12: "12. I am welcomed by Eastvantage on my first day.",
    q13: "13. What suggestions/recommendations do you have to improve our EV New Hire Orientation.",
    q14: "14. Let us know your Over-all New Hire Orientation Feedback.",
    selectFacilitator: "-Select Facilitator-",
    required: "This field is required",
  },
  fr: {
    title: "Nous aimerions connaître votre expérience d'intégration",
    intro: "Votre avis est important pour nous et nous aidera à améliorer l'expérience d'orientation des nouveaux employés. L'échelle de notation va de 1 à 5, 5 étant la note la plus élevée.",
    legend: ["1 - Très insatisfait(e)", "2 - Insatisfait(e)", "3 - Neutre", "4 - Satisfait(e)", "5 - Très satisfait(e)"],
    note: "Remarque : toutes les informations sont obligatoires, veuillez donc vous assurer que tous les champs sont remplis.",
    q1: "1. Quand avez-vous eu votre orientation des nouveaux employés ? (Date de la NHO)",
    q2: "2. Comment évalueriez-vous votre expérience globale d'intégration au cours de la première semaine chez Eastvantage ?",
    q3: "3. Comment évalueriez-vous votre expérience globale avec le processus de recrutement ?",
    q4: "4. Étiez-vous bien informé(e) concernant votre planning et votre programme pendant l'onboarding ?",
    q5: "5. Les sujets abordés lors de la séance d'orientation (NHO) sont pertinents pour une nouvelle recrue ?",
    q6: "6. Comment évaluez-vous le facilitateur ?",
    q7: "7. Le facilitateur était compétent sur les sujets abordés.",
    q8: "8. Le facilitateur a été capable de présenter les informations de manière claire et compréhensible.",
    q9: "9. Le facilitateur a été capable de répondre à mes questions.",
    q10: "10. Mon équipement EV fonctionne correctement.",
    q11: "11. J'ai pu me connecter à ma boîte mail, EVOX et BHR dès mon premier jour.",
    q12: "12. J'ai été bien accueilli(e) par Eastvantage le premier jour.",
    q13: "13. Quelles suggestions ou recommandations auriez-vous pour améliorer notre programme d'orientation des nouveaux employés ?",
    q14: "14. Merci de nous faire part de vos retours globaux sur l'orientation des nouveaux employés.",
    selectFacilitator: "-Sélectionnez le facilitateur-",
    required: "Ce champ est obligatoire",
  },
  nl: {
    title: "We horen graag over uw onboardingervaring",
    intro: "Uw feedback is belangrijk voor ons en helpt ons de New Hire Orientation-ervaring voor nieuwe medewerkers te verbeteren. De beoordelingsschaal loopt van 1 tot 5, waarbij 5 de hoogste score is.",
    legend: ["1 - Zeer ontevreden", "2 - Ontevreden", "3 - Neutraal", "4 - Tevreden", "5 - Zeer tevreden"],
    note: "Let op: alle informatie is verplicht, zorg er dus voor dat alle velden zijn ingevuld.",
    q1: "1. Wanneer had u uw New Hire Orientation? (Datum van de NHO)",
    q2: "2. Hoe beoordeelt u uw algemene onboardingervaring tijdens uw eerste week bij Eastvantage?",
    q3: "3. Hoe beoordeelt u uw ervaring met het wervings- en selectieproces?",
    q4: "4. Was het onboardingprogramma en de planning voor uw eerste dagen voldoende duidelijk?",
    q5: "5. Vond u de onderwerpen tijdens de New Hire Orientation (NHO) relevant en nuttig voor uw start bij Eastvantage?",
    q6: "6. Hoe beoordeelt u de begeleider van de NHO-sessie?",
    q7: "7. De begeleider beschikte over voldoende kennis van de behandelde onderwerpen.",
    q8: "8. De begeleider bracht de informatie op een duidelijke en begrijpelijke manier over.",
    q9: "9. De begeleider kon mijn vragen voldoende beantwoorden.",
    q10: "10. Mijn Eastvantage-apparatuur werkte naar behoren.",
    q11: "11. Vanaf mijn eerste werkdag had ik toegang tot mijn webmail, EVOX en BHR.",
    q12: "12. Op mijn eerste werkdag voelde ik mij welkom en goed ontvangen bij Eastvantage.",
    q13: "13. Heeft u suggesties of aanbevelingen om ons onboardingprogramma voor nieuwe medewerkers verder te verbeteren?",
    q14: "14. Heeft u nog andere feedback over uw onboardingervaring die u met ons wilt delen?",
    selectFacilitator: "-Selecteer begeleider-",
    required: "Dit veld is verplicht",
  },
};

export const nhoLanguages = [
  { code: "en", label: "English" },
  { code: "fr", label: "French" },
  { code: "nl", label: "Dutch" },
];

// Countries where the survey should open in French by default
export const NHO_FRENCH_DEFAULT_COUNTRIES = ["Morocco"];

export const getNhoDefaultLanguage = (country) =>
  NHO_FRENCH_DEFAULT_COUNTRIES.includes(country) ? "fr" : "en";

export const getNhoCanTranslate = (country) =>
  NHO_FRENCH_DEFAULT_COUNTRIES.includes(country);

export const getNhoTranslation = (lang) => nhoTranslations[lang] || nhoTranslations.en;

export default nhoTranslations;
